import createAsyncAction from "utils/createAsyncAction";
import isTabLockError from "editor/utils/isTabLockError";
import { differentTabLocked } from "editor/actions/status";

export const UPDATE_NEWSLETTER_CHUNK = "UPDATE_NEWSLETTER_CHUNK";
export const APPEND_NEWSLETTER_CHUNK = "APPEND_NEWSLETTER_CHUNK";
export const MOVE_NEWSLETTER_CHUNK_UP = "MOVE_NEWSLETTER_CHUNK_UP";
export const MOVE_NEWSLETTER_CHUNK_DOWN = "MOVE_NEWSLETTER_CHUNK_DOWN";
export const DELETE_NEWSLETTER_CHUNK = "DELETE_NEWSLETTER_CHUNK";
export const SEND_NEWSLETTER_REQUESTED = "SEND_NEWSLETTER_REQUESTED";
export const SEND_NEWSLETTER_SUCCEEDED = "SEND_NEWSLETTER_SUCCEEDED";
export const SEND_NEWSLETTER_FAILED = "SEND_NEWSLETTER_FAILED";
export const PUBLISH_NEWSLETTER_REQUESTED = "PUBLISH_NEWSLETTER_REQUESTED";
export const PUBLISH_NEWSLETTER_SUCCEEDED = "PUBLISH_NEWSLETTER_SUCCEEDED";
export const PUBLISH_NEWSLETTER_FAILED = "PUBLISH_NEWSLETTER_FAILED";
export const GET_NEWSLETTER_REQUESTED = "GET_NEWSLETTER_REQUESTED";
export const GET_NEWSLETTER_SUCCEEDED = "GET_NEWSLETTER_SUCCEEDED";
export const GET_NEWSLETTER_FAILED = "GET_NEWSLETTER_FAILED";

export const updateNewsletterChunk = (index, data) => ({
  type: UPDATE_NEWSLETTER_CHUNK,
  payload: { index, data },
});

export const appendNewsletterChunk = () => ({
  type: APPEND_NEWSLETTER_CHUNK,
});

export const moveNewsletterChunkUp = index => ({
  type: MOVE_NEWSLETTER_CHUNK_UP,
  payload: index,
});

export const moveNewsletterChunkDown = index => ({
  type: MOVE_NEWSLETTER_CHUNK_DOWN,
  payload: index,
});

export const deleteNewsletterChunk = index => ({
  type: DELETE_NEWSLETTER_CHUNK,
  payload: index,
});

export const updateNewsletterChunkAsync = (newsletterId, chunkId, body) => (
  dispatch,
  getState,
  getClient
) => {
  const {
    editor: {
      status: { editKey },
    },
  } = getState();

  const errorFunc = error => {
    if (isTabLockError(error)) {
      dispatch(differentTabLocked());
    }
  };

  return createAsyncAction(
    "newsletters",
    "chunkUpdate",
    "UPDATE_NEWSLETTER_CHUNK",
    args => args,
    errorFunc
  )(newsletterId, chunkId, body, editKey)(dispatch, getState, getClient);
};

export const sendNewsletterAsync = createAsyncAction(
  "newsletters",
  "send",
  "SEND_NEWSLETTER",
  args => args,
  error => {
    throw error;
  }
);

export const getNewsletterAsync = createAsyncAction(
  "newsletters",
  "read",
  "GET_NEWSLETTER"
);
